module.exports = __webpack_public_path__ + "static/media/default_kazehaya_sho4b3fdc4f441f3eca06beac9794b9479e.webp";